<template>
	<div>
		<div class="footer" id="" >
			<div class="footer-primary text-left" >
				<div class="container">
					<dl class="footer-help" style="left: 30px;">
						<dt>问题汇总</dt>
						<dd>
							<ul class="footer-links clearfix">
								<li>
                  <router-link :to="{path:'/problem'}">·&nbsp;&nbsp;常见问题</router-link>
								</li>
								<li>
                  <router-link :to="{path:'/opinion'}">·&nbsp;&nbsp;意见反馈</router-link>
								</li>
								<li>
                  <router-link :to="{path:'/aboutMe'}">·&nbsp;&nbsp;关于我们</router-link>
								</li>
								<li>
                  <router-link :to="{path:'/notice'}">·&nbsp;&nbsp;平台公告</router-link>
								</li>
								<li>
                  <router-link :to="{path:'/terraceUser'}">·&nbsp;&nbsp;隐私协议</router-link>
								</li>
								<li>
                  <router-link :to="{path:'/terrace'}">·&nbsp;&nbsp;用户协议</router-link>
								</li>
							</ul>
						</dd>
					</dl>
					<dl class="footer-service" style="margin: 0 300px;">
						<dt>联系客服</dt>
						<dd>
							<p class="call">
								<strong class="text-red">{{settingPc && settingPc.service_phone?settingPc.service_phone:'-'}}</strong>
								<small>（免费客服电话）</small>
							</p>
							<div class="online">
								<a class="btn btn-primary" href="javascript:;" @click="$fxLink.checkServier">
									<i class="iconfont icon-kefu"></i>
									在线咨询
								</a>
								<p class="time">{{settingPc && settingPc.work_time?settingPc.work_time:''}}</p>
							</div>
						</dd>
						<dd class="tips">
							<div class="alert alert-alt alert-danger">
								<s></s>
								<h4>请认准官方客服号码</h4>
								<p>如果您通过非官方客服号码进行咨询核销各种卡券造成损失，本平台概不负责。</p>
							</div>
						</dd>
					</dl>
					<dl class="footer-qrcode">
						<dd>
							<ul class="clearfix">
								<li>
									<img :src="settingPc && settingPc.wxmp_img?settingPc.wxmp_img.file_path:''" />
									<h5>{{$namePc}}公众号</h5>
								</li>
							</ul>
						</dd>
					</dl>
				</div>
			</div>
			<div class="footer-about">
				<div class="container">
					<ul class="authentication clearfix">
						<li>
							<a href="https://beian.miit.gov.cn/#/Integrated/index">
								<i class="iconimg iconimg-beian"></i>
								<span>
                  {{settingPc && settingPc.reg_no?settingPc.reg_no.split(' ')[0]:''}}
                  <br>
                  {{settingPc && settingPc.reg_no?settingPc.reg_no.split(' ')[1]:''}}
								</span>
							</a>
						</li>
						<li>
							<a href="http://www.cyberpolice.cn/wfjb/">
								<i class="iconimg iconimg-weifa"></i>
								<span>
									网络违法犯罪
									<br>
									举报中心
								</span>
							</a>
						</li>
						<li>
							<a href="https://www.12377.cn/">
								<i class="iconimg iconimg-buliang"></i>
								<span>
									不良信息
									<br>
									举报中心
								</span>
							</a>
						</li>
						<li>
							<a href="http://amr.hlj.gov.cn/">
								<i class="iconimg iconimg-gzaic"></i>
								<span>
									{{$province}}
									<br>
									行政管理局
								</span>
							</a>
						</li>

					</ul>
					<div class="copyright">
						<p>
              {{settingPc && settingPc.copyright?settingPc.copyright:''}}
						</p>
						<p>
							<a href="https://beian.miit.gov.cn/#/Integrated/index">
								工信部备案编号：{{settingPc &&  settingPc.reg_no?settingPc.reg_no:''}}
							</a>
						</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
	  name: 'Header',
	  data () {
	    return {
				contactUs:[],
        settingPc:{},
        url:""
	    }
	  },
		created() {
      this.url = window.location.hostname
      this.settingPc = JSON.parse(localStorage.getItem('settingPc'))

			this.contactUs = JSON.parse(localStorage.getItem('datum'))
      if(!this.settingPc){
        this.getSettings()
      }
      if(!this.contactUs){
        this.getContactUs()
      }
		},
		mounted(){

		},
		methods:{
      getSettings(){
        return new Promise((relove,reject) => {
          this.$api.systemsettings()
          .then(result => {
            localStorage.setItem('settingPc',JSON.stringify(result))
            this.$namePc = result.name
            relove(true)
          })
        })
      },
			getContactUs() {
				let token = localStorage.getItem('token')
				this.$api.connection({
						token: token,
					})
					.then(result => {
						this.contactUs = result.data
						localStorage.setItem("datum",JSON.stringify(result.data))
					})
			},
			changeActive($event){
				$event.currentTarget.className = 'open'

			},
			removeActive($event){
				$event.currentTarget.className = ''
			},

		}
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/footer.vue